var funciones = (function() {
  function wrap(text, width, lineHeight, debug) {
    debug = debug || false;
    text.each(function() {
      if (debug === true) {
        var t = d3.select(this);
        console.log(t.text());
        console.log("Ancho: " + width);
        console.log(t.node().getBBox());
      }
      var text = d3.select(this),
        words = text
          .text()
          .split(/\s+/)
          .reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = lineHeight || 1.1,
        x = text.attr("x") || 0,
        y = text.attr("y") || 0,
        dy = parseFloat(text.attr("dy") || 0),
        tspan = text
          .text(null)
          .append("tspan")
          .attr("x", x)
          .attr("y", y)
          .attr("dy", dy + "em")
          .attr("dominant-baseline", "alphabetic");
      while ((word = words.pop())) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          ++lineNumber;
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text
            .append("tspan")
            .attr("x", x)
            .attr("y", y)
            .attr("dy", lineNumber * lineHeight + dy + "em")
            .attr("dominant-baseline", "alphabetic")
            .text(word);
        }
      }
      if (debug === true) {
        var t = d3.select(this);
        console.log("Final");
        console.log(t.node().getBBox());
      }
    });
  }

  function getColores(n, h, s, v) {
    var CONJUGADO_PHI = 0.61803398874989484820458683436564;
    h = h || Math.random();
    s = s || 0.75;
    v = v || 0.9;
    var arreglo = [];
    var i;
    for (i = 0; i < n; i++) {
      h += CONJUGADO_PHI;
      arreglo.push(d3.hsv((h % 1) * 360, s - parseInt(h) * 0.04, v));
    }
    return arreglo;
  }

  function generaTooltips(rutas) {
    var opciones = {
      trigger: "custom",
      delay: 0,
      delayTouch: 0,
      animationDuration: 100,
      triggerOpen: {
        mouseenter: true,
        touchstart: true
      },
      triggerClose: {
        mouseleave: true,
        tap: true
      },
      contentAsHTML: true
    };
    rutas.each(function(d) {
      var contenido = "<p>" + d.etiqueta + "</p>";
      opciones.content = $(contenido);
      opciones.theme = "tooltipster-shadow";
      $(this).tooltipster(opciones);
    });
  }

  function getLargestRemainder(valores, total) {
    if (valores.length === 0) {
      return [];
    }
    if (total === 0) {
      valores = _.map(valores, function(v) {
        return 0;
      });
      return valores;
    }
    var diff, i, parts, sum, values, desiredSum;
    desiredSum = 100;
    var flagExtra = false;
    var suma = _.sum(valores);
    if (total > suma) {
      valores.push(total - suma);
      flagExtra = true;
    }
    values = _.map(valores, function(v) {
      return (v * desiredSum) / total;
    });
    sum = 0;
    parts = _.map(values, function(item, i) {
      var int;
      int = item | 0;
      sum += int;
      return {
        valor: int,
        decimal: item % 1,
        originalIndex: i
      };
    });
    //if (sum !== desiredSum) {
    if (sum < desiredSum) {
      parts = _.reverse(_.sortBy(parts, "decimal"));
      diff = desiredSum - sum;
      i = 0;
      while (i < diff) {
        parts[i].valor++;
        i++;
      }
    }
    var pcts = _.map(_.sortBy(parts, "originalIndex"), "valor");
    if (flagExtra === true) {
      pcts.pop();
    }
    return pcts;
  }

  return {
    wrap: wrap,
    getColores: getColores,
    generaTooltips: generaTooltips,
    getPorcentajes: getLargestRemainder
  };
})();
